// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import isInitialLoad from './is-initial-load';
import leadAccounts from './lead-accounts';
import selectedLeadAccount from './selected-lead-account';
import selectedPostingDate from './selected-posting-date';
import selectedValue from './selected-value';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    isInitialLoad,
    leadAccounts,
    selectedLeadAccount,
    selectedPostingDate,
    selectedValue
});



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/reducers/index.js